import React, { useEffect, useRef } from 'react';
import { Box, Typography } from '@mui/material';

/**
 * Полоса выбранного в окнах выбора (люди, работы): одна строка постоянной
 * высоты с горизонтальной прокруткой. Высота не меняется ни при первом выборе,
 * ни при десятом — список под полосой не прыгает под пальцем на айпаде.
 * Только что выбранное прокручивается в видимую часть.
 */
export default function SelectedStrip({ children, empty, sx }) {
    const ref = useRef(null);
    const count = React.Children.count(children);
    const prevCount = useRef(count);

    useEffect(() => {
        if (count > prevCount.current && ref.current) {
            ref.current.scrollLeft = ref.current.scrollWidth;
        }
        prevCount.current = count;
    }, [count]);

    return (
        <Box
            ref={ref}
            sx={{
                display: 'flex', alignItems: 'center', gap: 0.75,
                flexWrap: 'nowrap', overflowX: 'auto', overflowY: 'hidden',
                height: 48, flexShrink: 0, px: 1,
                bgcolor: '#f8fafc', border: '1px solid #e2e8f0', borderRadius: 1,
                WebkitOverflowScrolling: 'touch',
                ...sx,
            }}
        >
            {count > 0 ? children : (
                <Typography variant="caption" color="text.secondary" noWrap>{empty}</Typography>
            )}
        </Box>
    );
}
